/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {CommonModule} from '@angular/common';
import {ModuleWithProviders, NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';

import {TranslateModule} from '@ngx-translate/core';

import {AttachmentsComponent} from './attachments.component';
import {EmployeePayslipsComponent} from './employee-payslips.component';
import {EmployeesService} from './employees.service';
import {ReportDefinitionComponent} from './report-definition/report-definition.component';
import {ReportDefinitionService} from './report-definition/report-definition.service';
import {VariableZoneService} from './variable-zone/variable-zone.service';
import {VariableZonesComponent} from './variable-zone/variable-zones.component';

import {PdfJsViewerModule} from 'ng2-pdfjs-viewer';
import {CollapseModule} from 'ngx-bootstrap/collapse';
import {SkeletonElementsModule} from 'skeleton-elements/angular';
import {OngoingPayrollsService} from '../../+payrolls';
import {DocumentsModule} from '../../shared/documents/documents.module';
import {FilesModule} from '../files/files.module';
import {FormGeneratorModule} from '../form-generator/form-generator.module';
import {ImageManagementComponent} from '../image-management/image-management.component';
import {ModalModule} from '../modal/modal.module';
import {MvelModule} from '../mvel/mvel.module';
import {MvelService} from '../mvel/mvel.service';
import {PipesModule} from '../pipes/pipes.module';
import {UiModule} from '../ui/ui.module';
import {UserAvatarCropperComponent} from '../user/user-avatar-cropper.component';
import {UserModule} from '../user/user.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    TranslateModule,
    UserModule,
    UiModule,
    PipesModule,
    ModalModule,
    FilesModule,
    FormGeneratorModule,
    MvelModule,
    PdfJsViewerModule,
    CollapseModule,
    SkeletonElementsModule,
    DocumentsModule
  ],
  declarations: [
    ImageManagementComponent,
    EmployeePayslipsComponent,
    AttachmentsComponent,
    VariableZonesComponent,
    ReportDefinitionComponent,
    UserAvatarCropperComponent,
  ],
  exports: [
    ImageManagementComponent,
    EmployeePayslipsComponent,
    AttachmentsComponent,
    VariableZonesComponent,
    ReportDefinitionComponent,
    UserAvatarCropperComponent,
  ]
})
export class EmployeesSharedModule {
  public static forRoot(): ModuleWithProviders<EmployeesSharedModule> {
    return {
      ngModule: EmployeesSharedModule,
      providers: [
        EmployeesService,
        OngoingPayrollsService,
        VariableZoneService,
        ReportDefinitionService,
        MvelService
      ]
    };
  }
}
